import { render } from "./S195837.vue?vue&type=template&id=351354d8"
const script = {}
script.render = render

export default script